<template>
  <div class="col-md-10 ml-sm-auto pt-3 px-4 text-start home">
    <Loading :isLoading="isLoading" />

    <div class="row">
      <div class="col-md-8 vh-100">
        <h5 v-if="userStore.userInfo?.firstName" class="bold">
          Hello {{ userStore.userInfo?.firstName }}!
        </h5>
        <div class="card p-3 content-main">
          Welcome to the BioGaia order portal.
          <br /><br />If you have any questions regarding the portal, your
          Supply Account Manager is available to assist you with any
          portal-related questions while your Sales Manager can help with
          pricing inquiries. The contact information can be found on the
          right-hand side of this page.<br /><br />The artwork version numbers
          shown for the article are the current approved artwork version. Please
          note that you are only able to order the article with the artwork
          version numbers shown. If you wish to initiate a new artwork version,
          please reach out to the BioGaia Design Studio at
          artwork@biogaia.se.<br /><br />
          Once you’ve placed your order our official order confirmation with
          delivery date should be sent to you within the next 5 working days.
          <br /><br />
          If you need further support, please don’t hesitate to reach out. Have
          a wonderful day!
          <br /><br />
          <img
            src="../images/biogaia-vision.png"
            alt="Biogaia vision and mission"
          />
          <hr />
        </div>
      </div>
      <div class="col-md-4 vh-100">
        <div class="row text-center">
          <h5 v-if="userStore.userInfo?.companies" class="bold">
            Your Accounts
          </h5>
          <select
            v-if="userStore.userInfo?.companies"
            @change="onCompanyChange"
            v-model="selectedCompany"
            class="form-control mb-3"
          >
            <option
              v-for="value in userStore.sortedCompanies"
              :key="value.customerAccountNumber"
              :value="value"
            >
              {{ value.companyName }}
            </option>
          </select>
          <h5 class="bold">Your Biogaia contacts</h5>
          <ContactCard
            v-if="userStore.userInfo?.kamInfo"
            :Contact="userStore.userInfo?.kamInfo"
          />
          <ContactCard
            v-if="userStore.userInfo?.samInfo"
            :Contact="userStore.userInfo?.samInfo"
          />
          <ContactCard
            v-if="userStore.userInfo?.artwork"
            :Contact="userStore.userInfo?.artwork"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Vue } from "vue-facing-decorator";
import { useUserStore } from "@/store/userStore";
import { useProductsStore } from "@/store/productsStore";
import { useCartStore } from "@/store/cartStore";
import { useOrdersStore } from "@/store/ordersStore";
import Loading from "@/components/shared/Loading.vue";
import Newsitem from "@/components/home/NewsItem.vue";
import ContactCard from "@/components/home/ContactCard.vue";
import { Company } from "@/data/client";
@Component({
  components: { Loading, Newsitem, ContactCard },
})
class HomeView extends Vue {
  userStore = useUserStore();
  productStore = useProductsStore();
  orderStore = useOrdersStore();
  cartStore = useCartStore();
  selectedCompany: Company | null = null;
  isLoading = false;

  mounted() {
    const userInfo = this.userStore.userInfo;
    if (userInfo?.companies && userInfo.accountId) {
      this.selectedCompany =
        userInfo.companies.find((c) => c.accountId === userInfo.accountId) ??
        null;
    } else {
      this.selectedCompany = null;
    }
  }

  onCompanyChange() {
    const selectedCompany = this.selectedCompany;
    if (selectedCompany && this.userStore.userInfo) {
      this.userStore.setCustomerCompany(selectedCompany);
      this.productStore.emptyProductStore();
      this.cartStore.emptyCart();
      this.orderStore.emptyOrderStore();
    }
  }
}
export default HomeView;
</script>
